/* eslint-disable */
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-stop-definition',
  templateUrl: './stop-definition.page.html',
  styleUrls: ['./stop-definition.page.scss']
})
export class StopDefinitionPage implements OnInit {
  @ViewChild('slides', { static: false }) slides: IonSlides;
  slideIndex = 0;
  slideOpts: any = { allowTouchMove: false };

  constructor(
    private logger: LoggerService,
    private modalCtrl: ModalController
  ) {}

  updateSlideIndex() {
    Promise.all([this.slides.getActiveIndex()]).then((res) => {
      this.slideIndex = res[0];
    });
  }

  slidePrev() {
    this.slides.slidePrev();
    this.updateSlideIndex();
  }

  async slideNext() {
    const isEnd = await this.slides.isEnd();
    if (isEnd) {
      this.dismiss();
      return;
    }

    this.slides.slideNext();
    this.updateSlideIndex();
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  ionViewWillEnter() {
    this.slides.update();
  }

  ngOnInit() {}
}
